import React from "react";
import "./index.css";
import pixelLogo from "../../assests/pixelLogo.png";
import youtube from "../../assests/youtube.png";
import insta from "../../assests/insta.png";
import facebook from "../../assests/facebook.png";
import pinterest from "../../assests/pinterest.png";

import { Link, animateScroll as scroll } from "react-scroll";
import analytics from "../../firebase";
import { logEvent } from "@firebase/analytics";
import playstoreButton from "../../assests/playstoreButton.png";
import moreApps from "../../assests/moreApps.png";
import appleButton from "../../assests/appleButton.png"
import lindin from "../../assests/lindin.png"


import footerText from "../../assests/footerText.png"

function Footer() {
  return (
    <div className="footer_container">
      <div className="row">
        <div className="col-7 colClass">
          <div className="footer_col">
            <div className="title_footer justify-content-center">
              {/* <img src={pixelLogo} className="footer_logo"></img> */}
              <img src={footerText} className="footerTextImg"></img>
            </div>
            <p className="footerText">
              {" "}
              pixellab is the easiest photo editing app that offers PRO features
              for free. You can make professional looking photos in just one
              click.
            </p>

            <div className="d-flex justify-content-center">
              <div className="">
                <div className="footer_btn">
                  <div className="appstore footer_button">
                    <a
                      href="https://apps.apple.com/app/id1577960583"
                      target="_blank"
                      className="icon_link"
                      onClick={() => {
                        logEvent(analytics, "app_store", {
                          name: "app_store",
                        });
                      }}
                    >
                      <img src={appleButton}></img>
                    </a>
                  </div>
                  <div
                    className="gpay footer_button"
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    <a
                      href="https://play.google.com/store/apps/details?id=com.app.pixellab.editor"
                      target="_blank"
                      className="icon_link"
                      onClick={() => {
                        logEvent(analytics, "play_store", {
                          name: "play_store",
                        });
                      }}
                    >
                      <img src={playstoreButton}></img>
                    </a>
                  </div>

                  <div className="gpay footer_button">
                    <a
                      href="https://apps.apple.com/developer/komal-shiyani/id1658958603"
                      target="_blank"
                      className="icon_link"
                      onClick={() => {
                        logEvent(analytics, "more_app", {
                          name: "more_app",
                        });
                      }}
                    >
                      <img src={moreApps}></img>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-3 colClass">
          <div className="footer_col">
            <div className="title_footer">Help</div>

            <Link
              to="questions"
              spy={true}
              smooth={true}
              duration={500}
              className="footer_link"
            >
              FAQ's
            </Link>

            <a
              className="footer_link"
              href="http://release.law.blog/2019/08/23/pixellab-text-on-pictures-privacy-policy/"
              target="_blank"
            >
              Privacy Policy
            </a>
            <a
              className="footer_link"
              href="mailto:Jstechnovation@gmail.com?body=support"
            >
              Support
            </a>

            <a
              className="footer_link"
              href="http://release.law.blog/2019/08/23/pixellab-text-on-pictures-privacy-policy/"
              target="_blank"
            >
              Terms & Condition
            </a>
            <a
              className="footer_link"
              href="https://release.law.blog/contact/"
              target="_blank"
            >
              contact
            </a>
          </div>
        </div>
        <div className="col-2 colClass">
          <div className="media_icon color-1">
            <a
              href="https://www.facebook.com/pixellab.Drip.Collagemaker"
              target="_blank"
              className="white_border"
            >
              <img src={facebook}></img>
            </a>
          </div>
          <div className="media_icon color-1">
            <a
              href="https://www.youtube.com/@pixellabPicCollageMaker"
              target="_blank"
              className="white_border"
            >
              <img src={youtube}></img>{" "}
            </a>
          </div>
          <div className="media_icon color-1">
            <a
              href="https://pinterest.com/PicShotBackgroundEraser/"
              target="_blank"
              className="white_border"
            >
              <img src={pinterest}></img>{" "}
            </a>
          </div>

          <div className="media_icon color-1">
            <a
              href="https://www.instagram.com/pixellab.pic_collager_maker"
              target="_blank"
              className="white_border"
            >
              <img src={insta}></img>{" "}
            </a>
          </div>
          <div className="media_icon color-1">
            <a
              href="https://www.linkedin.com/company/pixellab-pic-collage-maker"
              target="_blank"
              className="white_border"
            >
              <img src={lindin} style={{ borderRadius: "50%" }}></img>{" "}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
